module.exports = __webpack_public_path__ + "img/edit.f6f80d6f.svg";